import React, {ReactElement} from 'react';
import './slide.css';
import './workshop.component.css';
import Elements from '../element/elements';
import {ISlide} from '../../incase-domain/slide';
import {DeviceType} from '../../incase-domain/common/DeviceType.enum';
import {isCoverHtmlElement} from '../../incase-domain/elements/html';
import {useSlideDrawing} from './useSlideDrawing';

interface SlideProps {
    slide: ISlide;
    device?: DeviceType;
}

function Slide(props: SlideProps): ReactElement {
    const {slide, device = DeviceType.DESKTOP} = props;

    const {canvasRef, drawEnabled, handlers} = useSlideDrawing(slide);

    if (!slide.elements) {
        return <div />;
    }

    const coverSlideFillsMobile = device === DeviceType.MOBILE && slide.elements.some((element) => isCoverHtmlElement(element));

    return (
        <div
            role="none"
            {...handlers}
            style={coverSlideFillsMobile ? {flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', marginBottom: 0} : undefined}
        >
            <canvas
                id={`pencil-canvas-${slide._id}`}
                ref={canvasRef}
                className={drawEnabled ? 'pencil-canvas' : 'pencil-canvas pencil-canvas-disabled'}
                width={canvasRef.current?.clientWidth}
                height={canvasRef.current?.clientHeight}
                style={device === DeviceType.MOBILE ? {display: 'none'} : {}}
            />

            <Elements slide={slide} device={device} />
        </div>
    );
}

export default Slide;
